import { Fragment, useRef, useState } from 'react';

import { arrow, offset, safePolygon, useFloating, useHover, useInteractions } from '@floating-ui/react';
import { clsx } from 'clsx';

import { NavItem } from '@spacefill/uikit/src/components/Sidebar/NavItem';

export function TopBarProfile({ profileTopNavigation = [], profileNavigation = [], userInfo }) {
    const [isOpen, setIsOpen] = useState(false);
    const arrowRef = useRef(null);
    const { refs, floatingStyles, context } = useFloating({
        open: isOpen,
        onOpenChange: setIsOpen,
        placement: 'bottom-end',
        middleware: [
            offset({ mainAxis: 12 }),
            arrow({
                element: arrowRef,
            }),
        ],
    });

    const hover = useHover(context, {
        handleClose: safePolygon({
            buffer: 1,
        }),
    });
    const { getReferenceProps, getFloatingProps } = useInteractions([hover]);

    const getInitials = (userName) => {
        if (!userName) return '';
        const names = userName.trim().split(' ');
        if (names.length >= 2) {
            return `${names[0][0]}${names[names.length - 1][0]}`.toUpperCase();
        }
        return names[0][0].toUpperCase();
    };

    return (
        <div
            className='relative'
            ref={refs.setReference}
            {...getReferenceProps()}
        >
            <div
                className={clsx(
                    'flex h-8 w-8 items-center justify-center rounded-full bg-gray-600 text-sm font-medium text-sidebar-foreground hover:cursor-pointer hover:bg-gray-500 hover:ring-2 hover:ring-sidebar-foreground/20',
                    {
                        'bg-gray-500 ring-2 ring-sidebar-foreground/30': isOpen,
                    }
                )}
            >
                {getInitials(userInfo.userName)}
            </div>

            {isOpen && (
                <div
                    ref={refs.setFloating}
                    style={floatingStyles}
                    {...getFloatingProps()}
                    className='z-sidebar rounded-md bg-sidebar-background p-2 min-w-[200px]'
                >
                    <div className='mb-2 px-3 py-2'>
                        <div className='truncate text-sm text-sidebar-foreground'>
                            <p className='font-medium'>{userInfo.userName}</p>
                            <p className='text-xs opacity-80'>{userInfo.company}</p>
                        </div>
                    </div>

                    {profileTopNavigation.length > 0 && (
                        <Fragment>
                            <hr className='my-1 border-zinc-600' />
                            <ul>
                                {profileTopNavigation.map((props, idx) => (
                                    <NavItem
                                        {...props}
                                        key={`profile-top-item-${idx}`}
                                    />
                                ))}
                            </ul>
                        </Fragment>
                    )}

                    {profileNavigation.length > 0 && (
                        <Fragment>
                            <hr className='my-1 border-zinc-600' />
                            <ul>
                                {profileNavigation.map((props, idx) => (
                                    <NavItem
                                        {...props}
                                        key={`profile-item-${idx}`}
                                        isSubNav
                                    />
                                ))}
                            </ul>
                        </Fragment>
                    )}
                </div>
            )}
        </div>
    );
}
